module.exports = __webpack_public_path__ + "static/media/marker.eaeb2e6c.svg";